<div class="cell auto grid-y cell-block-y blockContent">
    <table cellspacing="4" *ngIf="study">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'study.balance.sheet.active'"></th>
            <th class="_numberColumn"[i18nKey]="'study.balance.sheet.gross'"></th>
            <th class="_numberColumn"[i18nKey]="'study.balance.sheet.amortization'"></th>
            <th class="_numberColumn"[i18nKey]="'study.balance.sheet.net'"></th>
            <th [i18nKey]="'study.balance.sheet.passive'"></th>
            <th class="_numberColumn"[i18nKey]="'study.balance.sheet.amount'"></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'study.balance.sheet.intangible.asset'"></td>
            <td class="_number">{{study.intangibleAsset | number:'1.2'}}</td>
            <td></td>
            <td class="_number">{{study.intangibleAsset | number:'1.2'}}</td>
            <td [i18nKey]="'study.balance.sheet.capital'"></td>
            <td class="_number">{{study.capital | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'study.balance.sheet.furniture'"></td>
            <td class="_number">{{study.grossFurniture | number:'1.2'}}</td>
            <td class="_number">{{study.furnitureAmortization | number:'1.2'}}</td>
            <td class="_number">{{study.netFurniture | number:'1.2'}}</td>
            <td [i18nKey]="'study.balance.sheet.legal.reserve'"></td>
            <td class="_number">{{study.legalReserve | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'study.balance.sheet.tableware'"></td>
            <td class="_number">{{study.grossTableware | number:'1.2'}}</td>
            <td class="_number">{{study.tablewareAmortization | number:'1.2'}}</td>
            <td class="_number">{{study.netTableware | number:'1.2'}}</td>
            <td [i18nKey]="'study.balance.sheet.optional.reserve'"></td>
            <td class="_number">{{study.optionalReserve | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="_totalColumn"[i18nKey]="'study.balance.sheet.fixed.assets'"></td>
            <td></td>
            <td></td>
            <td class="_number _totalColumn">{{study.fixedAssets | number:'1.2'}}</td>
            <td [i18nKey]="'study.balance.sheet.retained.earnings'"></td>
            <td class="_number">{{study.retainedEarnings | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'study.balance.sheet.cellar'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.cellar | number:'1.2'}}</td>
            <td [i18nKey]="'study.balance.sheet.net.result'"></td>
            <td class="_number">{{study.netResult | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'common.taxes.vat.input'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.vatInput | number:'1.2'}}</td>
            <td class="_totalColumn"[i18nKey]="'study.balance.sheet.equity'"></td>
            <td class="_number _totalColumn">{{study.equity | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'study.balance.sheet.payment.tax'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.paymentTax | number:'1.2'}}</td>
            <td [i18nKey]="'study.balance.sheet.loan'"></td>
            <td class="_number">{{study.loan | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="_totalColumn"[i18nKey]="'study.balance.sheet.current.assets'"></td>
            <td></td>
            <td></td>
            <td class="_number _totalColumn">{{study.currentAssets | number:'1.2'}}</td>
            <td [i18nKey]="'common.taxes.vat.output'"></td>
            <td class="_number">{{study.vatOutput | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'study.balance.sheet.investment'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.investment | number:'1.2'}}</td>
            <td [i18nKey]="'study.balance.sheet.income.tax'"></td>
            <td class="_number">{{study.incomeTax | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'study.balance.sheet.bank'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.bank | number:'1.2'}}</td>
            <td [i18nKey]="'study.balance.sheet.overdraft'"></td>
            <td class="_number">{{study.overdraft | number:'1.2'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'study.balance.sheet.sale.assets'"></td>
            <td></td>
            <td></td>
            <td class="_number _totalColumn">{{study.saleAssets | number:'1.2'}}</td>
            <td class="_totalColumn"[i18nKey]="'study.balance.sheet.debts'"></td>
            <td class="_number _totalColumn">{{study.debts | number:'1.2'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'study.balance.sheet.assets.total'"></td>
            <td></td>
            <td></td>
            <td class="_number _totalColumn">{{study.assetsTotal | number:'1.2'}}</td>
            <td class="_totalColumn"[i18nKey]="'study.balance.sheet.liabilities.total'"></td>
            <td class="_number _totalColumn">{{study.liabilitiesTotal | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>
</div>
